/* Deviceli: snappier navigation. Prefetch pages on hover/touch (for browsers without
   speculation rules), and fade product images in once they have loaded. */
(function(){
  var done = {}, canSpec = HTMLScriptElement.supports && HTMLScriptElement.supports('speculationrules');
  function ok(a){
    if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download')) return false;
    var u; try { u = new URL(a.href, location.href); } catch(e){ return false; }
    if (u.origin !== location.origin || u.search || u.hash && u.pathname === location.pathname) return false;
    return !/^\/(cart|checkout|checkouts|account)/.test(u.pathname) && u.pathname !== location.pathname;
  }
  function pre(e){
    if (canSpec) return;
    var a = e.target.closest && e.target.closest('a');
    if (!ok(a) || done[a.href]) return;
    done[a.href] = 1;
    var l = document.createElement('link'); l.rel = 'prefetch'; l.href = a.href; document.head.appendChild(l);
  }
  document.addEventListener('mouseover', pre, {passive:true});
  document.addEventListener('touchstart', pre, {passive:true});

  function fade(img){
    if (img.dataset.fd) return; img.dataset.fd = 1;
    if (img.complete && img.naturalWidth) return;
    img.classList.add('ld');
    var off = function(){ img.classList.remove('ld'); };
    img.addEventListener('load', off, {once:true}); img.addEventListener('error', off, {once:true});
    setTimeout(off, 2500);
  }
  function scan(root){ (root.querySelectorAll ? root : document).querySelectorAll('img.dev').forEach(fade); }
  scan(document);
  new MutationObserver(function(m){ m.forEach(function(r){ r.addedNodes.forEach(function(n){ if (n.nodeType === 1){ if (n.matches && n.matches('img.dev')) fade(n); else scan(n); } }); }); })
    .observe(document.body, {childList:true, subtree:true});
})();
